/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

import { type ConsentDto } from '@src/api-clients/guest-api-client';
import { useUserConsent, useConsentForm } from '@src/features/user-consent/hooks';

export type FirstPartyConsentProps = {
  guestConsents?: ConsentDto[];
  errorMessage?: string;
};

export const FirstPartyConsent = ({ guestConsents }: FirstPartyConsentProps) => {
  const { consentStatus } = useUserConsent();
  const { register, unregister } = useConsentForm();

  const hasPreviouslyConsentedToFirstParty = guestConsents?.some((consent) => consent.type === 'first-party') ?? false;
  const hasPreviouslyConsentedToMarketingViaUserCentrics = (consentStatus.ucCategory as any)?.marketing === true;

  useEffect(() => {
    if (hasPreviouslyConsentedToFirstParty || !hasPreviouslyConsentedToMarketingViaUserCentrics) {
      unregister('consents.first-party');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPreviouslyConsentedToFirstParty, hasPreviouslyConsentedToMarketingViaUserCentrics]);

  return (
    <>
      {!hasPreviouslyConsentedToFirstParty && hasPreviouslyConsentedToMarketingViaUserCentrics && (
        <input
          type="hidden"
          {...register?.('consents.first-party', {
            value: true,
          })}
        />
      )}
    </>
  );
};
